module.exports = __webpack_public_path__ + "static/media/gordijnen-2.0535cc0d.jpg";